import DOMPurify from 'isomorphic-dompurify';

// External links open in a NEW TAB. We force target="_blank" (so embedded web
// links never navigate away from the page) and the safe rel so _blank can't
// be used for reverse-tabnabbing. tel:/mailto: links are intentionally left in
// the same context — they hand off to the native dialer / mail client, so a
// blank tab would just orphan an empty window. The TipTap schema's Link mark
// defaults every anchor to target="_blank" regardless of protocol, so this
// hook is the authoritative place that strips it back off for tel:/mailto:.
//
// DOMPurify is a shared singleton, so this must be registered before ANY
// sanitize call — every module that sanitizes imports it for that reason
// rather than relying on another module having been loaded first.
DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.nodeName !== 'A') {
    return;
  }
  const href = node.getAttribute('href') ?? '';
  const isExternal = /^https?:/i.test(href);
  if (isExternal) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  } else if (/^(tel|mailto):/i.test(href)) {
    node.removeAttribute('target');
    node.removeAttribute('rel');
  } else if (node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});
